import { styles as basicStyles } from '../common2/BasicSelect/styles';

export const styles = {
  ...basicStyles,
  option: (provided, state) => ({
    ...basicStyles.option(provided, state),
    height: 64,
  }),
};
